module.exports = __webpack_public_path__ + "img/facebook.79b1d59e.png";